import { rewardRegularReq,rewardReqWithoutLogin } from '@/utils/request';
export function gameUserInit(params={}){
    return rewardReqWithoutLogin({
        url: '/cook-manage-admin/api/ops/activity/game/userInit',
        method: 'get',
        params
    })
}
export function gameStart(params={}){
    return rewardReqWithoutLogin({
        url: '/cook-manage-admin/api/ops/activity/game/startPlay',
        method: 'get',
        params
    })
}
export function gameSharerInit(params={}){
    return rewardReqWithoutLogin({
        url: '/cook-manage-admin/api/ops/activity/game/clickShare',
        method: 'get',
        params
    })
}
//获取sign
export function getSign(params){
    return rewardReqWithoutLogin({
        url: '/cook-manage-admin/api/ops/activity/game/getSign',
        method: 'get',
        params
    })
}
export function getResult(params){
    return rewardReqWithoutLogin({
        url: '/cook-manage-admin/api/ops/activity/game/getResult',
        method: 'get',
        params
    })
}



// WEBPACK FOOTER //
// ./src/api/dunhuang.js